import { Button, CircularProgress, Divider,  TextField, MenuItem, Select } from '@mui/material';
import { useRef, useEffect, useState } from 'react';
import BrandFilter from '../comp/brandfilter';
import ProductBarcodeAuto from "../comp/prodbarcodeauto";
import ProductNameAuto from "../comp/prodnameauto";
import BrandNameAuto from '../comp/brandnameauto';
import '../css/modal.css'


const DiscountMod = ({ handleClose, token, open, custrow, handleModal, handleRefresh}) => {

    const discount_prcnt = useRef();
    const dis_threashold = useRef();

    const [selected, setSelected] = useState({ prod_code: "Баркод", prod_name: "Бүтээгдэхүүний Нэр" });
    const [brandselected, setbrandSelected] = useState({ id: "1", brand_name: "Брэнд Нэр" });
    const [helber, setHelber] = useState("quantity");
    const [hemjih, setHemjih] = useState("product");
    const [inputVal] = useState({});
    const [inputValbrand] = useState({});
    const [options, setOptions] = useState([]);

    const [prodload, setProdload] = useState(false);

    const handleEscape = (e) => {
        if (e.keyCode == 27) {
            handleClose(false);
        }
    }

    useEffect(() => {

        // pcre.current.value = custrow.prod_rcre_time;
        console.log("dis_brand_id: "+custrow.dis_brand_id);
        if(custrow.dis_brand_id != "0")
        {
            setHemjih("brand");
        }
        setHelber(custrow.dis_type);
        setSelected({ prod_code: custrow.dis_prod_code, prod_name: custrow.dis_prod_name });
        setbrandSelected({id: custrow.dis_brand_id, brand_name: custrow.dis_brand_name});
        discount_prcnt.current.value = custrow.discount_prcnt;
        dis_threashold.current.value = custrow.dis_threashold;

    }, [])

    useEffect(() => {
        window.addEventListener('keyup', handleEscape);
        return () => {
            window.removeEventListener('keyup', handleEscape);
        }
    }, [handleEscape])

    const handleClick = () => {
        if (open) {
            handleModal(false);
        }
    }

    const handleSubmit = () => {
        setProdload(true);
        if(hemjih == "product")
        {
            var req = {
            'dis_type': helber,
            'dis_prod_code': selected.prod_code,
            'dis_prod_name': selected.prod_name,
            'discount_prcnt': discount_prcnt.current.value,
            'dis_threashold': dis_threashold.current.value,
        }
        }
        if(hemjih == "brand")
        {
            var req = {
            'dis_type': helber,
            'dis_brand_id' : brandselected.id,
            'dis_brand_name': brandselected.brand_name,
            'discount_prcnt': discount_prcnt.current.value,
            'dis_threashold': dis_threashold.current.value,
        }
        }
        


        console.log(JSON.stringify(req));

        const request = new Request('https://wms-cloud.com/api/DiscountProduct/'+custrow.id , {
        //const request = new Request('http://localhost:8080/Brand',{
            method: 'PUT',
            body: JSON.stringify(req),
            headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${token}` })
        });

        fetch(request).then((response) => {
            if (response.status == 200) {
                
                setProdload(false);
                handleClose(false);
                return response.json();
                

            } else {
                console.log("aldaa garsan" + JSON.stringify(response));
                alert("Амжилтгүй "+ JSON.stringify(response) );
                setProdload(false);
            }
        }).then((resp) => {
            
            console.log(resp);
            if(resp.console=="Success")
            {
                handleRefresh();
            }
            else
            {
                alert(resp.err_Msg)
            }
            
        });
    }

    const handleChange = (e) => {
        setHelber(e.target.value);

    }

    const handleHemjihChange = (e) => {
        setHemjih(e.target.value);
    }

    
    const getBrandDataforname = (e) => {
        var tok = localStorage.getItem("tok");
        var url = "";
        if (e == null) {
            url = 'https://wms-cloud.com/api/Brand?_start=0&_end=50&brand_name=' + selected.prod_name;

        } else {
            url = 'https://wms-cloud.com/api/Brand?_start=0&_end=50&brand_name=' + e.target.value;
        }
        const request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tok}`,
                
                'Access-Control-Allow-Headers': 'X-Total-Count'
            })
        });

        fetch(request).then(
            (response) => {
                if (response.status == 200) {
                    return response.json();
                } else if (response.status == 500) {
                    alert("Алдаа гарлаа дахин оролдоно уу.");
                } else {
                    localStorage.removeItem('tok');
                    window.location.reload(false);
                    alert("Алдаа гарлаа.")
                }
            }
        ).then((resp) => {
            console.log("from here 2");
            var temp = [];
            resp.map((e) => {
                temp.push({ "id": e.id, "brand_name": e.brand_name });
            });
            setOptions(temp);
        });
    }

    const getdataforname = (e) => {
        var tok = localStorage.getItem("tok");
        var url = "";
        if (e == null) {
            url = 'https://wms-cloud.com/api/Products?_start=0&_end=50&prod_name=' + selected.prod_name;

        } else {
            url = 'https://wms-cloud.com/api/Products?_start=0&_end=50&prod_name=' + e.target.value;
        }
        const request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tok}`,
                
                'Access-Control-Allow-Headers': 'X-Total-Count'
            })
        });

        fetch(request).then(
            (response) => {
                if (response.status == 200) {
                    return response.json();
                } else if (response.status == 500) {
                    alert("Алдаа гарлаа дахин оролдоно уу.");
                } else {
                    localStorage.removeItem('tok');
                    window.location.reload(false);
                    alert("Алдаа гарлаа.")
                }
            }
        ).then((resp) => {
            console.log("from here 2");
            var temp = [];
            resp.map((e) => {
                temp.push({ "prod_code": e.prod_code, "prod_name": e.prod_name, "prod_price": e.prod_price, "prod_uldegdel": e.prod_uldegdel });
            });
            setOptions(temp);
        });
    }

    const getdataforbar = (e) => {
        console.log("changevallen" + e);
        var tok = localStorage.getItem("tok");

        var url = "";
        if (e == null) {
            console.log("e null");
            url = 'https://wms-cloud.com/api/Products?_start=0&_end=50&q=' + selected.prod_code;

        } else {
            url = 'https://wms-cloud.com/api/Products?_start=0&_end=50&q=' + e.target.value;
        }
        const request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tok}`,
                
                'Access-Control-Allow-Headers': 'X-Total-Count'
            })
        });

        fetch(request).then(
            (response) => {
                if (response.status == 200) {
                    return response.json();
                } else if (response.status == 500) {
                    alert("Алдаа гарлаа дахин оролдоно уу.");
                } else {
                    localStorage.removeItem('tok');
                    window.location.reload(false);
                    alert("Алдаа гарлаа.")
                }
            }
        ).then((resp) => {
            console.log("from here 2");
            var temp = [];
            resp.map((e) => {
                temp.push({ "prod_code": e.prod_code, "prod_name": e.prod_name, "prod_price": e.prod_price, "prod_uldegdel": e.prod_uldegdel });
            });
            setOptions(temp);
        });
    }

    const handleDelete = () => {
        const request = new Request('https://wms-cloud.com/api/DiscountProduct/'+custrow.id , {
            //const request = new Request('http://localhost:8080/Brand/'+custrow.id , {
                method: 'DELETE',
                headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${token}` })
            });
    
            fetch(request).then((response) => {
                if (response.status == 200) {
                    console.log(response.body);
                    setProdload(false);
                    handleClose(false);
                    handleRefresh();
    
                } else {
                    console.log("aldaa garsan" + JSON.stringify(response));
                    alert("Амжилтгүй "+ JSON.stringify(response) );
                    setProdload(false);
                }
            });
    }

    return <div className="custmodal" >
    <div className="mcont">
        <div className="mheader">
            Бүтээгдхүүн хямдрал засах
        <button aria-label="Хаах" onClick={() => handleClick()}>✕</button>
        </div>
        <Divider />
        <div className="mccont">
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <Select style={{ marginLeft: "5px" }}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={helber}
                                        label="Хямдралын төрөл"
                                        onChange={handleChange}
                                    >
                                        <MenuItem key={"price"} value={"price"}>{"Үнийн дүнгээр"}</MenuItem>
                                        <MenuItem key={"quantity"} value={"quantity"}>{"Тоо ширхэгээр"}</MenuItem>
                        </Select>
                    </div>
                </div>

                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <Select style={{ marginLeft: "5px" }}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={hemjih}
                                        label="Хямдралын хэмжих хэлбэр"
                                        onChange={handleHemjihChange}
                                    >
                                        <MenuItem key={"product"} value={"product"}>{"Бүтээгдхүүнээр"}</MenuItem>
                                        <MenuItem key={"brand"} value={"brand"}>{"Брэндээр"}</MenuItem>
                        </Select>
                    </div>
                </div>
                {hemjih == "product" ?
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <ProductBarcodeAuto selected={selected} label="Баркод" setProd={setSelected} options={options} getdataforbar={getdataforbar} inputVal={inputVal} />
                        <div>{selected.prod_price!=undefined?" Баркод: "+selected.prod_code+" Нэр: "+selected.prod_name+" "+"Үнэ: "+selected.prod_price+" "+"Үлдэгдэл: "+selected.prod_uldegdel:""}</div>
                    </div>
                </div>
                :<div></div> }
                {hemjih == "product" ?
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                    <ProductNameAuto selected={selected} label="Барааны нэр" setProd={setSelected} options={options} getdataforbar={getdataforname} inputVal={inputVal}/>
                    <div>{selected.prod_price!=undefined?" Баркод: "+selected.prod_code+" Нэр: "+selected.prod_name+" "+"Үнэ: "+selected.prod_price+" "+"Үлдэгдэл: "+selected.prod_uldegdel:""}</div>
                    </div>
                </div>
                :<div></div> }
                
                {hemjih == "brand" ?
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                                        {/* <TextField inputRef={pnuminbox} label="Brand" type="number" fullWidth ></TextField> */}
                        <BrandNameAuto selected ={brandselected} label ="Брэндийн нэр" setProd={setbrandSelected} options={options} getdataforbar={getBrandDataforname} inputVal={inputValbrand}></BrandNameAuto>
                    </div>
                </div>
                :<div></div> }
                <div className="crow">
                <div style={{  width: "100%", paddingRight: "10px" }}>
                    <TextField inputRef={discount_prcnt} type="number" label="Хямдрах хувь" fullWidth ></TextField>
                </div>
                </div>
                <div className="crow">
                <div style={{  width: "100%", paddingRight: "10px" }}>
                    <TextField inputRef={dis_threashold} type="number" label="Хямдралын хязгаар /тоо, үнэ/" fullWidth ></TextField>
                </div>
                </div>
        </div>
        <div className="mfooter">
            <Button className="mfooterstart" variant="outlined" color="error" onClick={handleDelete}>Устгах</Button>
            <Button onClick={handleClick}>Буцах</Button>
            <Button variant="contained" onClick={handleSubmit}>Хадгалах</Button>
        </div>
        {prodload ?
            <div className="prodload">
                <CircularProgress />
            </div> : ""
        }
    </div>
    </div>

}

export default DiscountMod;


